import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { AdminShell } from '../components/Layout/AdminShell.js';
import { RequireAdmin } from '../components/Layout/RequireAdmin.js';
import { LoginPage } from '../features/auth/LoginPage.js';
import { DashboardPage } from '../features/dashboard/DashboardPage.js';
import { CustomersListPage } from '../features/customers/CustomersListPage.js';
import { CustomerDetailPage } from '../features/customers/CustomerDetailPage.js';
import { KycQueuePage } from '../features/kyc/KycQueuePage.js';
import { KycReviewPage } from '../features/kyc/KycReviewPage.js';
import { TransfersListPage } from '../features/transfers/TransfersListPage.js';
import { TransferDetailPage } from '../features/transfers/TransferDetailPage.js';
import { RatesManagerPage } from '../features/rates/RatesManagerPage.js';
import { FeesManagerPage } from '../features/fees/FeesManagerPage.js';
import { PromoCodePage } from '../features/promocodes/PromoCodePage.js';
import { StaffPage } from '../features/staff/StaffPage.js';
import { AuditLogPage } from '../features/audit/AuditLogPage.js';
import { SettingsPage } from '../features/settings/SettingsPage.js';
import { NotFoundPage } from '../features/errors/NotFoundPage.js';

const protectedShell: RouteObject = {
  element: (
    <RequireAdmin>
      <AdminShell />
    </RequireAdmin>
  ),
  children: [
    { path: '/', element: <DashboardPage /> },
    { path: '/customers', element: <CustomersListPage /> },
    { path: '/customers/:id', element: <CustomerDetailPage /> },
    {
      path: '/kyc',
      element: (
        <RequireAdmin allow={['super_admin', 'compliance_reviewer']}>
          <KycQueuePage />
        </RequireAdmin>
      ),
    },
    {
      path: '/kyc/:id',
      element: (
        <RequireAdmin allow={['super_admin', 'compliance_reviewer']}>
          <KycReviewPage />
        </RequireAdmin>
      ),
    },
    { path: '/transfers', element: <TransfersListPage /> },
    { path: '/transfers/:id', element: <TransferDetailPage /> },
    {
      path: '/rates',
      element: (
        <RequireAdmin allow={['super_admin', 'operator']}>
          <RatesManagerPage />
        </RequireAdmin>
      ),
    },
    {
      path: '/fees',
      element: (
        <RequireAdmin allow={['super_admin', 'operator']}>
          <FeesManagerPage />
        </RequireAdmin>
      ),
    },
    {
      path: '/promo-codes',
      element: (
        <RequireAdmin allow={['super_admin', 'operator']}>
          <PromoCodePage />
        </RequireAdmin>
      ),
    },
    {
      path: '/staff',
      element: (
        <RequireAdmin allow={['super_admin']}>
          <StaffPage />
        </RequireAdmin>
      ),
    },
    { path: '/audit', element: <AuditLogPage /> },
    {
      path: '/settings',
      element: (
        <RequireAdmin allow={['super_admin', 'operator']}>
          <SettingsPage />
        </RequireAdmin>
      ),
    },
  ],
};

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  protectedShell,
  { path: '/404', element: <NotFoundPage /> },
  { path: '*', element: <Navigate to="/404" replace /> },
]);
